module.exports = __webpack_public_path__ + "static/media/loading.b5272405.svg";